
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/freight-dictionary/[title]",
      function () {
        return require("private-next-pages/freight-dictionary/[title]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/freight-dictionary/[title]"])
      });
    }
  